// src/store/index.js
//
// Relocated from src/rds_ui/store/index.js. This is the app's global Redux
// store — src/main.jsx wraps the whole app in its <Provider>, so it belongs
// at the app level, not nested inside one feature module (rds_ui) that
// main.jsx then has to reach into. Content unchanged; only the location
// (and the two import paths that pointed at it) changed.
import { configureStore } from '@reduxjs/toolkit'
import validationReducer from './slices/validationSlice'
import refinementReducer from './slices/refinementSlice'

export const store = configureStore({
  reducer: {
    validation: validationReducer,
    refinement: refinementReducer,
  },
})
